import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Profile from "../views/Profile.vue";
import Login from "../views/auth/Login.vue";
import store from "../store";
const routes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: 'Login' }
  },
  {
    path: "/",
    name: "/",
    redirect: "/login",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true }
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true }
  },
  //page routes
  {
    path: "/pages",
    name: "Pages",
    component: () => import("../views/Pages/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/pages/create",
    name: "PageCreate",
    component: () => import("../views/Pages/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/pages/:id/edit",
    name: "PageEdit",
    component: () => import("../views/Pages/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //Sections routes
  {
    path: "/sections",
    name: "Sections",
    component: () => import("../views/Sections/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/sections/create",
    name: "SectionCreate",
    component: () => import("../views/Sections/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/sections/:id/edit",
    name: "SectionEdit",
    component: () => import("../views/Sections/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //blog routes
  {
    path: "/blogDetails",
    name: "BlogDetails",
    component: () => import("../views/BlogDetails/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/blogDetails/create",
    name: "BlogDetailCreate",
    component: () => import("../views/BlogDetails/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/blogDetails/:id/edit",
    name: "BlogDetailEdit",
    component: () => import("../views/BlogDetails/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //blog routes
  {
    path: "/blogs",
    name: "Blogs",
    component: () => import("../views/Blogs/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/blogs/create",
    name: "BlogCreate",
    component: () => import("../views/Blogs/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/blogs/:id/edit",
    name: "BlogEdit",
    component: () => import("../views/Blogs/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //branches routes
  {
    path: "/branches",
    name: "Branches",
    component: () => import("../views/Branches/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/branches/create",
    name: "BranchCreate",
    component: () => import("../views/Branches/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/branches/:id/edit",
    name: "BranchEdit",
    component: () => import("../views/Branches/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //achievements routes
  {
    path: "/achievements",
    name: "Achievements",
    component: () => import("../views/Achievements/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/achievements/create",
    name: "AchievementCreate",
    component: () => import("../views/Achievements/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/achievements/:id/edit",
    name: "AchievementEdit",
    component: () => import("../views/Achievements/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //countryInvestments routes
  {
    path: "/countryInvestments",
    name: "CountryInvestments",
    component: () => import("../views/CountryInvestments/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/countryInvestments/create",
    name: "CountryInvestmentCreate",
    component: () => import("../views/CountryInvestments/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/countryInvestments/:id/edit",
    name: "CountryInvestmentEdit",
    component: () => import("../views/CountryInvestments/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //citizenship country routes
  {
    path: "/citizenshipPrograms",
    name: "CitizenshipPrograms",
    component: () => import("../views/CitizenshipPrograms/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipPrograms/create",
    name: "CitizenshipProgramCreate",
    component: () => import("../views/CitizenshipPrograms/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipPrograms/:id/edit",
    name: "CitizenshipProgramEdit",
    component: () => import("../views/CitizenshipPrograms/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //citizenship country routes
  {
    path: "/citizenshipCountries",
    name: "CitizenshipCountries",
    component: () => import("../views/CitizenshipCountries/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipCountries/create",
    name: "CitizenshipCountryCreate",
    component: () => import("../views/CitizenshipCountries/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipCountries/:id/edit",
    name: "CitizenshipCountryEdit",
    component: () => import("../views/CitizenshipCountries/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //citizenship offers routes
  {
    path: "/citizenshipOffers",
    name: "CitizenshipProgramOffers",
    component: () => import("../views/CitizenshipProgramOffers/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipOffers/create",
    name: "CitizenshipProgramOfferCreate",
    component: () => import("../views/CitizenshipProgramOffers/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipOffers/:id/edit",
    name: "CitizenshipProgramOfferEdit",
    component: () => import("../views/CitizenshipProgramOffers/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //citizenship facts routes
  {
    path: "/citizenshipCountryFacts",
    name: "CitizenshipCountryFacts",
    component: () => import("../views/CitizenshipCountryFacts/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipCountryFacts/create",
    name: "CitizenshipCountryFactCreate",
    component: () => import("../views/CitizenshipCountryFacts/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipCountryFacts/:id/edit",
    name: "CitizenshipCountryFactEdit",
    component: () => import("../views/CitizenshipCountryFacts/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //citizenship benefits routes
  {
    path: "/citizenshipCountryBenefits",
    name: "CitizenshipCountryBenefits",
    component: () => import("../views/CitizenshipCountryBenefits/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipCountryBenefits/create",
    name: "CitizenshipCountryBenefitCreate",
    component: () => import("../views/CitizenshipCountryBenefits/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipCountryBenefits/:id/edit",
    name: "CitizenshipCountryBenefitEdit",
    component: () => import("../views/CitizenshipCountryBenefits/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //citizenship process routes
  {
    path: "/citizenshipCountryProcesses",
    name: "CitizenshipCountryProcesses",
    component: () => import("../views/CitizenshipCountryProcesses/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipCountryProcesses/create",
    name: "CitizenshipCountryProcessCreate",
    component: () => import("../views/CitizenshipCountryProcesses/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipCountryProcesses/:id/edit",
    name: "CitizenshipCountryProcessEdit",
    component: () => import("../views/CitizenshipCountryProcesses/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //citizenship requirement routes
  {
    path: "/citizenshipCountryRequirements",
    name: "CitizenshipCountryRequirements",
    component: () => import("../views/CitizenshipCountryRequirements/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipCountryRequirements/create",
    name: "CitizenshipCountryRequirementCreate",
    component: () => import("../views/CitizenshipCountryRequirements/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipCountryRequirements/:id/edit",
    name: "CitizenshipCountryRequirementEdit",
    component: () => import("../views/CitizenshipCountryRequirements/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //Value routes
  {
    path: "/values",
    name: "Values",
    component: () => import("../views/Values/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/values/create",
    name: "ValueCreate",
    component: () => import("../views/Values/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/values/:id/edit",
    name: "ValueEdit",
    component: () => import("../views/Values/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //passportBenefits  routes
  {
    path: "/passportBenefits",
    name: "PassportBenefits",
    component: () => import("../views/PassportBenefits/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/passportBenefits/create",
    name: "PassportBenefitCreate",
    component: () => import("../views/PassportBenefits/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/passportBenefits/:id/edit",
    name: "PassportBenefitEdit",
    component: () => import("../views/PassportBenefits/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //citizenshipBenefits  routes
  {
    path: "/citizenshipBenefits",
    name: "CitizenshipBenefits",
    component: () => import("../views/CitizenshipBenefits/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipBenefits/create",
    name: "CitizenshipBenefitCreate",
    component: () => import("../views/CitizenshipBenefits/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipBenefits/:id/edit",
    name: "CitizenshipBenefitEdit",
    component: () => import("../views/CitizenshipBenefits/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //citizenshipFaqs routes
  {
    path: "/citizenshipFaqs",
    name: "CitizenshipFaqs",
    component: () => import("../views/CitizenshipFaqs/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipFaqs/create",
    name: "CitizenshipFaqCreate",
    component: () => import("../views/CitizenshipFaqs/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipFaqs/:id/edit",
    name: "CitizenshipFaqEdit",
    component: () => import("../views/CitizenshipFaqs/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //citizenshipDetails routes
  {
    path: "/citizenshipDetails",
    name: "CitizenshipDetails",
    component: () => import("../views/CitizenshipDetails/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipDetails/create",
    name: "CitizenshipDetailCreate",
    component: () => import("../views/CitizenshipDetails/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/citizenshipDetails/:id/edit",
    name: "CitizenshipDetailEdit",
    component: () => import("../views/CitizenshipDetails/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //investments programs routes
  {
    path: "/residencyPrograms",
    name: "InvestmentPrograms",
    component: () => import("../views/InvestmentPrograms/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyPrograms/create",
    name: "InvestmentProgramCreate",
    component: () => import("../views/InvestmentPrograms/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyPrograms/:id/edit",
    name: "InvestmentProgramEdit",
    component: () => import("../views/InvestmentPrograms/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //investments options routes
  {
    path: "/investmentOptions",
    name: "InvestmentOptions",
    component: () => import("../views/InvestmentOptions/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/investmentOptions/create",
    name: "InvestmentOptionCreate",
    component: () => import("../views/InvestmentOptions/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/investmentOptions/:id/edit",
    name: "InvestmentOptionEdit",
    component: () => import("../views/InvestmentOptions/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //investments options routes
  {
    path: "/residencyCountries",
    name: "InvestmentCountries",
    component: () => import("../views/InvestmentCountries/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyCountries/create",
    name: "InvestmentCountryCreate",
    component: () => import("../views/InvestmentCountries/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyCountries/:id/edit",
    name: "InvestmentCountryEdit",
    component: () => import("../views/InvestmentCountries/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //citizenship process routes
  {
    path: "/residencyCountryProcesses",
    name: "InvestmentCountryProcesses",
    component: () => import("../views/InvestmentCountryProcesses/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyCountryProcesses/create",
    name: "InvestmentCountryProcessCreate",
    component: () => import("../views/InvestmentCountryProcesses/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyCountryProcesses/:id/edit",
    name: "InvestmentCountryProcessEdit",
    component: () => import("../views/InvestmentCountryProcesses/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //investment facts routes
  {
    path: "/residencyCountryFacts",
    name: "InvestmentCountryFacts",
    component: () => import("../views/InvestmentCountryFacts/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyCountryFacts/create",
    name: "InvestmentCountryFactCreate",
    component: () => import("../views/InvestmentCountryFacts/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyCountryFacts/:id/edit",
    name: "InvestmentCountryFactEdit",
    component: () => import("../views/InvestmentCountryFacts/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //investment benefits routes
  {
    path: "/residencyCountryBenefits",
    name: "InvestmentCountryBenefits",
    component: () => import("../views/InvestmentCountryBenefits/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyCountryBenefits/create",
    name: "InvestmentCountryBenefitCreate",
    component: () => import("../views/InvestmentCountryBenefits/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyCountryBenefits/:id/edit",
    name: "InvestmentCountryBenefitEdit",
    component: () => import("../views/InvestmentCountryBenefits/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //investment requirement routes
  {
    path: "/residencyCountryRequirements",
    name: "InvestmentCountryRequirements",
    component: () => import("../views/InvestmentCountryRequirements/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyCountryRequirements/create",
    name: "InvestmentCountryRequirementCreate",
    component: () => import("../views/InvestmentCountryRequirements/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyCountryRequirements/:id/edit",
    name: "InvestmentCountryRequirementEdit",
    component: () => import("../views/InvestmentCountryRequirements/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //investment requirement routes
  {
    path: "/residencyCountryFees",
    name: "InvestmentCountryFees",
    component: () => import("../views/InvestmentCountryFees/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyCountryFees/create",
    name: "InvestmentCountryFeeCreate",
    component: () => import("../views/InvestmentCountryFees/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyCountryFees/:id/edit",
    name: "InvestmentCountryFeeEdit",
    component: () => import("../views/InvestmentCountryFees/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //investment requirement routes
  {
    path: "/residencyFaqs",
    name: "InvestmentFaqs",
    component: () => import("../views/InvestmentFaqs/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyFaqs/create",
    name: "InvestmentFaqCreate",
    component: () => import("../views/InvestmentFaqs/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyFaqs/:id/edit",
    name: "InvestmentFaqEdit",
    component: () => import("../views/InvestmentFaqs/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //investment requirement routes
  {
    path: "/residencyBenefits",
    name: "InvestmentBenefits",
    component: () => import("../views/InvestmentBenefits/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyBenefits/create",
    name: "InvestmentBenefitCreate",
    component: () => import("../views/InvestmentBenefits/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/residencyBenefits/:id/edit",
    name: "InvestmentBenefitEdit",
    component: () => import("../views/InvestmentBenefits/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //investments countries routes
  {
    path: "/goldenVisaBenefits",
    name: "GoldenVisaBenefits",
    component: () => import("../views/GoldenVisaBenefits/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaBenefits/create",
    name: "GoldenVisaBenefitCreate",
    component: () => import("../views/GoldenVisaBenefits/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaBenefits/:id/edit",
    name: "GoldenVisaBenefitEdit",
    component: () => import("../views/GoldenVisaBenefits/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //investments countries routes
  {
    path: "/goldenVisaCountries",
    name: "GoldenVisaCountries",
    component: () => import("../views/GoldenVisaCountries/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaCountries/create",
    name: "GoldenVisaCountryCreate",
    component: () => import("../views/GoldenVisaCountries/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaCountries/:id/edit",
    name: "GoldenVisaCountryEdit",
    component: () => import("../views/GoldenVisaCountries/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //investment facts routes
  {
    path: "/goldenVisaCountryFacts",
    name: "GoldenVisaCountryFacts",
    component: () => import("../views/GoldenVisaCountryFacts/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaCountryFacts/create",
    name: "GoldenVisaCountryFactCreate",
    component: () => import("../views/GoldenVisaCountryFacts/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaCountryFacts/:id/edit",
    name: "GoldenVisaCountryFactEdit",
    component: () => import("../views/GoldenVisaCountryFacts/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //investment benefits routes
  {
    path: "/goldenVisaCountryBenefits",
    name: "GoldenVisaCountryBenefits",
    component: () => import("../views/GoldenVisaCountryBenefits/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaCountryBenefits/create",
    name: "GoldenVisaCountryBenefitCreate",
    component: () => import("../views/GoldenVisaCountryBenefits/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaCountryBenefits/:id/edit",
    name: "GoldenVisaCountryBenefitEdit",
    component: () => import("../views/GoldenVisaCountryBenefits/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //investments programs routes
  {
    path: "/goldenVisaPrograms",
    name: "GoldenVisaPrograms",
    component: () => import("../views/GoldenVisaPrograms/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaPrograms/create",
    name: "GoldenVisaProgramCreate",
    component: () => import("../views/GoldenVisaPrograms/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaPrograms/:id/edit",
    name: "GoldenVisaProgramEdit",
    component: () => import("../views/GoldenVisaPrograms/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //golden visa offers routes
  {
    path: "/goldenVisaProgramOffers",
    name: "GoldenVisaProgramOffers",
    component: () => import("../views/GoldenVisaProgramOffers/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaProgramOffers/create",
    name: "GoldenVisaProgramOfferCreate",
    component: () => import("../views/GoldenVisaProgramOffers/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaProgramOffers/:id/edit",
    name: "GoldenVisaProgramOfferEdit",
    component: () => import("../views/GoldenVisaProgramOffers/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //golden visa offers routes
  {
    path: "/goldenVisaInvestmentOptions",
    name: "GoldenVisaInvestmentOptions",
    component: () => import("../views/GoldenVisaInvestmentOptions/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaInvestmentOptions/create",
    name: "GoldenVisaInvestmentOptionCreate",
    component: () => import("../views/GoldenVisaInvestmentOptions/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaInvestmentOptions/:id/edit",
    name: "GoldenVisaInvestmentOptionEdit",
    component: () => import("../views/GoldenVisaInvestmentOptions/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //citizenshipFaqs routes
  {
    path: "/goldenVisaFaqs",
    name: "GoldenVisaFaqs",
    component: () => import("../views/GoldenVisaFaqs/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaFaqs/create",
    name: "GoldenVisaFaqCreate",
    component: () => import("../views/GoldenVisaFaqs/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/goldenVisaFaqs/:id/edit",
    name: "GoldenVisaFaqEdit",
    component: () => import("../views/GoldenVisaFaqs/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //contacts routes
  {
    path: "/contacts",
    name: "Contact",
    component: () => import("../views/Contacts/ContactList.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/contacts/:id/show",
    name: "ContactShow",
    component: () => import("../views/Contacts/ContactShow.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //Passport welcome countries routes
  {
    path: "/passport-welcome-countries",
    name: "PassportWelcomeCountries",
    component: () => import("../views/PassportWelcomeCountries/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/passport-welcome-countries/create",
    name: "PassportWelcomeCountryCreate",
    component: () => import("../views/PassportWelcomeCountries/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/passport-welcome-countries/:id/edit",
    name: "PassportWelcomeCountryEdit",
    component: () => import("../views/PassportWelcomeCountries/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
];
const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});
router.beforeEach((to, from, next) => {
  const requiresAuth = to.meta.requiresAuth;
  const isLoggedIn = store.getters['auth/isLoggedIn'];
  console.log(`Navigating to: ${to.name}, Requires Auth: ${requiresAuth}, Is Logged In: ${isLoggedIn}`);

  if (requiresAuth && !isLoggedIn) {
    next({ name: 'Login' });
  } else {
    next();
  }
});

export default router;
